import Marquee from "react-fast-marquee";
import { Figures, FiguresRoot, Title } from "./MinFigures.styled";

export default function MintFigures() {

  return (
    <FiguresRoot>      
      <Title>
        <Marquee style={{"overflowY": "hidden", "zIndex": 0}}> 
          <Title><b>BASEJUMP&nbsp;</b>IS POWERED BY&nbsp;<b>ACTION</b></Title>
        </Marquee>
      </Title>
      <Figures src="/assets/mint_figures.png"/>
    </FiguresRoot>
  )
}
